import { CSS_PROPS, OTHER_PROPS } from 'common/constants/component-props';

export const VISUAL_COMPARE_MODE = {
	divider: 'divider',
	fade: 'fade',
	spotlight: 'spotlight',
} as const;

type ObjectValues<T> = T[keyof T];

export type VisualCompareMode = ObjectValues<typeof VISUAL_COMPARE_MODE>;

export const visualCompareDataSelector = {
	lineSize: 'visual-compare-line-size',
	lineFill: 'visual-compare-line-styles',
	handleSize: 'visual-compare-handle-size',
	handleFill: 'visual-compare-handle-fill',
	spotlight: 'visual-compare-spotlight',
};

export const spotlightConfig = {
	fadeIntensity: 50, //
	blurStart: 35, // %
	size: '15.63vw', // approx. 200px for 1280px screen (desktop platform min)
};

export function createSpotlightSize(size: string) {
	return `${size} ${size}`.trim();
}

export function createSpotlightBlur(blur: number) {
	if (!Number.isFinite(blur)) return '';
	const blurEnd = spotlightConfig.blurStart + spotlightConfig.blurStart * (blur / 100);
	return `radial-gradient(rgb(0, 0, 0) ${spotlightConfig.blurStart}%, transparent ${blurEnd}%)`;
}

export const defaultProps = {
	[OTHER_PROPS.visualCompare.visualCompareMode]: VISUAL_COMPARE_MODE.divider,
	[CSS_PROPS.visualCompare.visualCompareSpotlightSize]: createSpotlightSize(spotlightConfig.size),
	[CSS_PROPS.visualCompare.visualCompareSpotlightBlur]: createSpotlightBlur(spotlightConfig.fadeIntensity),
};
